import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  InputAdornment,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import {
  Courses,
  setDialog,
} from "../../../app/slices/Course/coursesSlice";
import { SelectCompany } from "../../Selects/SelectCompany";

const ModalInfo = () => {
  const dispatch = useDispatch();
  const {
    dialog,
    loading,
    form: {
      id,
      name,
      description,
      duration,
      seats_count,
      price,
      company_id,
      is_active,
      apply_link,
    },
  } = useSelector((state) => state.courses.manageCourse);

  const [formData, setFormData] = useState({
    id,
    name,
    description,
    duration,
    seats_count,
    price,
    company_id,
    is_active,
    attachment: null,
    apply_link,
  });
  
  const [fileSelected, setFileSelected] = useState("");

  useEffect(() => {
    setFormData({
      id,
      name,
      description,
      duration,
      seats_count,
      price,
      company_id,
      is_active: typeof is_active === 'number' ? Boolean(is_active) : is_active,
      attachment: null,
      apply_link,
    });
    setFileSelected("");
  }, [id, name, description, duration, seats_count, price, company_id, is_active, apply_link]);

  const handleClose = () => {
    dispatch(setDialog());
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setFormData({
        ...formData,
        attachment: e.target.files[0]
      });
      setFileSelected(e.target.files[0].name);
    }
  };

  const handleSwitchChange = (e) => {
    setFormData({
      ...formData,
      is_active: e.target.checked,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (formData.id) {
      dispatch(Courses.update(formData.id, formData));
    } else {
      dispatch(Courses.create(formData));
    }
  };

  return (
    <Dialog
      open={dialog}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="md"
      fullWidth
    >
      <DialogTitle id="alert-dialog-title">
        {id ? "Edit Course" : "Add Course"}
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                required
                fullWidth
                label="Course Name"
                name="name"
                value={formData.name}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <SelectCompany
                value={formData.company_id}
                onChange={(e, newValue) => {
                  console.log("Selected company:", newValue);
                  setFormData({ ...formData, company_id: newValue });
                }}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                required
                fullWidth
                label="Description"
                name="description"
                value={formData.description}
                onChange={handleChange}
                multiline
                rows={4}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                required
                fullWidth
                label="Duration"
                name="duration"
                value={formData.duration}
                onChange={handleChange}
                placeholder="e.g. 8 weeks"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                required
                fullWidth
                label="Seats Count"
                name="seats_count"
                type="number"
                value={formData.seats_count}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                required
                fullWidth
                label="Price"
                name="price"
                value={formData.price}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Apply Link"
                name="apply_link"
                value={formData.apply_link}
                onChange={handleChange}
                placeholder="https://example.com/apply"
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="outlined"
                component="label"
                fullWidth
                startIcon={<CloudUploadIcon />}
                sx={{ height: "56px" }}
              >
                Upload Attachment
                <input
                  type="file"
                  hidden
                  accept="image/*,.pdf"
                  onChange={handleFileChange}
                />
              </Button>
              {fileSelected && (
                <Typography variant="caption" sx={{ mt: 1 }}>
                  File selected: {fileSelected}
                </Typography>
              )}
            </Grid>
            <Grid item xs={12}>
              <Box display="flex" alignItems="center">
                <Typography>Active</Typography>
                <Switch
                  checked={formData.is_active}
                  onChange={handleSwitchChange}
                  inputProps={{ "aria-label": "controlled" }}
                />
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="error">
            Cancel
          </Button>
          <Button
            type="submit"
            color="primary"
            variant="contained"
            disabled={loading}
          >
            {id ? "Update" : "Add"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default ModalInfo; 